import { HTTP_FILE } from './http-service';

class RemediationDateHistoryEvidenceService {
  getRemediationDateHistoryDownloadUrl(link) {
    return HTTP_FILE.get(
      `/RemediationDateFile/download/${encodeURIComponent(link)}`
    ).then((response) => {
      return response.data;
    });
  }
}

export default new RemediationDateHistoryEvidenceService();
